export default __webpack_public_path__ + "static/media/wallet03.0fb8c3ce.png";